export default __webpack_public_path__ + "images/b52205ca9b33972b671225e24d9ec0b6.svg";